import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { ArrowLeft, Mail } from 'lucide-react'
import { toast } from 'sonner'
import { apiService } from '@/services/api'
import { AuthLayout } from './AuthLayout'

export function PasswordRecoveryScreen() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) {
      toast.error('Informe seu e-mail')
      return
    }
    try {
      const res = await apiService.recoverPassword(email)
      setSent(true)
      toast.success(res.message)
    } catch (err: any) {
      toast.error(err.message || 'Erro ao solicitar recuperação de senha')
    }
  }

  const handleResend = async () => {
    try {
      const res = await apiService.recoverPassword(email)
      toast.success(res.message)
    } catch (err: any) {
      toast.error(err.message || 'Erro ao reenviar o email')
    }
  }

  return (
    <AuthLayout>
      <div className="rounded-lg border border-border bg-card p-6 shadow-sm sm:p-8">
        {sent ? (
          <div className="flex flex-col items-center text-center">
            <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-accent">
              <Mail className="h-6 w-6 text-accent-foreground" />
            </span>
            <h2 className="text-xl font-bold">Email enviado</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Se o e-mail estiver cadastrado, você receberá instruções para
              redefinir a senha. Confira também a caixa de spam.
            </p>
            <Button variant="outline" className="mt-6 w-full" onClick={handleResend}>
              Reenviar email
            </Button>
          </div>
        ) : (
          <>
            <div className="mb-6">
              <h2 className="text-xl font-bold">Recuperar senha</h2>
              <p className="mt-1 text-sm text-muted-foreground">
                Informe seu e-mail para receber o link de redefinição.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="recovery-email">E-mail</Label>
                <Input
                  id="recovery-email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoFocus
                  autoComplete="email"
                  inputMode="email"
                />
              </div>
              <Button type="submit" className="w-full">Enviar link de recuperação</Button>
            </form>
          </>
        )}

        <button
          type="button"
          onClick={() => navigate('/login')}
          className="mt-6 flex w-full cursor-pointer items-center justify-center gap-2 border-none bg-transparent p-0 text-sm text-link hover:underline"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar ao login
        </button>
      </div>
    </AuthLayout>
  )
}
